import { DialogParams, ContainerPhotosAdapter } from "../types";
import { useExporterShipmentAdapter } from "./useExporterShipmentAdapter";
import { useImporterContractAdapter } from "./useImporterContractAdapter";
import { useExporterTaskAdapter } from "./useExporterTaskAdapter";
import { useExporterSingleAdapter } from "./useExporterSingleAdapter";
import { useSharedEmailAdapter } from "./useSharedEmailAdapter";

export const useAdapterFactory = (
  params: DialogParams
): ContainerPhotosAdapter => {
  const exporterShipmentAdapter = useExporterShipmentAdapter(
    params.mode === "exporter-shipment" ? params.shipmentId : 0
  );
  const importerContractAdapter = useImporterContractAdapter(
    params.mode === "importer-contract" ? params.shipmentId : 0
  );
  const exporterTaskAdapter = useExporterTaskAdapter(
    params.mode === "exporter-task" ? params.taskIds : []
  );
  const exporterSingleAdapter = useExporterSingleAdapter(
    params.mode === "exporter-single" ? params.containerId : 0,
    params.mode === "exporter-single" ? params.taskId : undefined,
    params.mode === "exporter-single" ? params.shipmentId : undefined
  );
  const sharedEmailAdapter = useSharedEmailAdapter(
    params.mode === "shared-email"
      ? {
          shipmentId: params.shipmentId,
          shipmentShareKey: params.shipmentShareKey,
          isPreview: params.isPreview,
        }
      : { shipmentId: 0 }
  );

  switch (params.mode) {
    case "exporter-shipment":
      return exporterShipmentAdapter;
    case "importer-contract":
      return importerContractAdapter;
    case "exporter-task":
      return exporterTaskAdapter;
    case "exporter-single":
      return exporterSingleAdapter;
    case "shared-email":
      return sharedEmailAdapter;
    default: {
      const _exhaustiveCheck: never = params;
      throw new Error(`Unhandled adapter mode: ${(_exhaustiveCheck as DialogParams).mode}`);
    }
  }
};
